var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',_vm._b({ref:"calcCostCard"},'v-card',_vm.cardProps,false),[_c('v-card-text',[_c('div',{staticStyle:{"width":"100%","background-color":"#ccc","min-height":"700px"}},[(_setup.fileUrl)?_c(_setup.PdfViewer,{attrs:{"pdfUrl":_setup.fileUrl,"onClick":async () => {
            await _setup.withLoading(async () => {
              await _setup.downloadFileByKey(_vm.obtain_file ?? null);
            });
          }}}):_c('span',[_vm._v("※ 수주서 PDF 미리보기 영역")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }